<div class="trial-counter-trial-block" [style]="{ 'width' : trialStatus().blockWidth, 'height' : trialStatus().blockHeight }">
  <div class="trial-chip-container">
    <div class="trial-counter-space" [ngClass]="trialStatus().class" [style]="{ 'margin-left' : trialStatus().leftMargin, 'width' : trialStatus().chipWidth, 'height' : trialStatus().chipHeight }"></div>
  </div>
</div>
